import { Injectable } from '@angular/core';

import { DatacenterDefaultConfiguration } from '../../shared/datacenter/datacenter-default-configuration';
import { ECALL_BY_VOLUME_DATACENTER_TYPE } from '../../shared/models/datacenter-aggrid-view';
import { DatacenterFilterUtilsService } from '../../shared/services/datacenter-filter-utils.service';
import { DatacenterViewService } from '../../shared/services/datacenter-view.service';

import { ECallOffViewService } from './ecall-off-view-service';

@Injectable({ providedIn: 'root' })
export class ECallOffByVolumeViewService extends ECallOffViewService {
	constructor(
		defaultConfiguration: DatacenterDefaultConfiguration,
		filterUtils: DatacenterFilterUtilsService,
		viewService: DatacenterViewService
	) {
		super(ECALL_BY_VOLUME_DATACENTER_TYPE, defaultConfiguration, filterUtils, viewService);
	}
}
